import {
  isRelativeDateValue,
  RelativeDatePeriod,
  RelativeDateUnit,
  type RelativeDateValue,
  type QueryBuilderRuleValue,
} from '@ardoq/api-types';

const DEFAULT_RELATIVE_DATE: RelativeDateValue = {
  period: RelativeDatePeriod.THIS,
  unit: RelativeDateUnit.WEEK,
};

export const ensureRelativeDateValue = (
  value: QueryBuilderRuleValue
): RelativeDateValue => {
  if (!isRelativeDateValue(value)) {
    return DEFAULT_RELATIVE_DATE;
  }
  return value;
};

export const isCalendarWeek = (value: RelativeDateValue): boolean =>
  value.unit === RelativeDateUnit.WEEK && !('amount' in value);
